module.exports = __webpack_public_path__ + "img/add.3fae5a4d.svg";